import { ClosePayroll, Footer, Header, Movements, Row } from './types'
import { getData } from '../get-table'
import { HttpService } from '../http.service'
import { API_NEW, ENV } from '../../env'
export * from './types'

const http = new HttpService()

const httpAws = new HttpService(API_NEW[ENV()]())

export async function getClosedPayrolls(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = '',
  countryId?: string
): Promise<any> {
  const queryMx = [`stamped_payrolls.id AS stamped_payroll_id`]
  const joinMx = [
    `LEFT JOIN stamped_payrolls ON closed_payrolls.id = stamped_payrolls.closed_payroll_id AND stamped_payrolls.is_deleted = false`
  ]

  // where's
  const where = ['closed_payrolls.payroll_id = :payrollId']
  if (search) {
    where.push(
      `CONCAT(employees.code, employees.name, concepts.name, processes.name, processed_payrolls.start_date, processed_payrolls.end_date, processed_payrolls.neto, closed_payrolls.closed_by, closed_payrolls.closed_date) ILIKE '%${search}%'`
    )
  }
  // order by
  const modifier = [
    `GROUP BY closed_payrolls.id , processed_payrolls.id, processes.name, processes.code, companies.id, employees.first_name, employees.lastname, concepts.code, concepts.name, process_status.name${
      countryId === 'MX' ? ', stamped_payrolls.id' : ''
    }`
  ]
  dataOrder !== ''
    ? modifier.push(`order by ${dataOrder[1]} ${dataOrder[0]}`)
    : modifier.push('order by end_date desc')
  // result
  const response: any = await getData({
    tables: ['pg_closed_payrolls'],
    fields: [
      'closed_payrolls.id',
      'processes.name as process',
      'processes.code as process_code',
      'processed_payrolls.start_date',
      'processed_payrolls.end_date',
      "CONCAT(employees.first_name,' ',employees.lastname) as first_employee",
      'jsonb_array_length(processed_payrolls.employees) - 1 AS left_employees',
      "CONCAT(concepts.code,'-',concepts.name) as first_concept",
      'jsonb_array_length(processed_payrolls.concepts) - 1 AS left_concepts',
      "COALESCE(string_agg(distinct concepts.name,','),'') as concepts",
      'processed_payrolls.neto',
      ...(countryId === 'MX' ? queryMx : []),
      'closed_payrolls.closed_by',
      'closed_payrolls.closed_date',
      'processed_payrolls.process_request_id',
      'processed_payrolls.id as processedId',
      'closed_payrolls.ledger_transactions',
      'companies.integrations AS integrations',
      `companies.custom_fields ->> 'custom:SAPAllowAutomaticAccounting' AS sap_allow_automatic_accounting`,
      'process_status.name as status_accounting'
    ],
    join: [
      'JOIN processed_payrolls ON closed_payrolls.processed_payroll_id = processed_payrolls.id and closed_payrolls.is_deleted = false and processed_payrolls.is_deleted = false',
      'JOIN processes ON processed_payrolls.process_id = processes.id',
      'JOIN payrolls ON closed_payrolls.payroll_id = payrolls.id and payrolls.is_deleted = false',
      'JOIN companies ON payrolls.company_id = companies.id and companies.is_deleted = false',
      'JOIN employees ON employees.id = (processed_payrolls.employees ->> 0)::uuid',
      'JOIN concepts ON concepts.id = (processed_payrolls.concepts ->> 0)::uuid',
      'LEFT JOIN process_status ON closed_payrolls.status_accounting_id = process_status.id',
      ...(countryId === 'MX' ? joinMx : [])
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })

  return response
}

export async function getDataProcessedPayroll(id: string): Promise<any> {
  const response: any = await getData({
    tables: ['pg_processed_payrolls'],
    fields: [
      'processed_payrolls.id',
      "CONCAT(payrolls.code,' - ',payrolls.name) as payrollName",
      'payroll_status.code as status',
      'upper(payroll_status.name) as statusName',
      'processes.name as type',
      'processes.code as processCode',
      "TO_CHAR(processed_payrolls.start_date,'dd-mm-yyyy') as startDate",
      "TO_CHAR(processed_payrolls.end_date,'dd-mm-yyyy') as endDate",
      "TO_CHAR(processed_payrolls.start_date,'yyyy-mm-dd') as startDate2",
      "TO_CHAR(processed_payrolls.end_date,'yyyy-mm-dd') as endDate2",
      'processed_payrolls.used_variables as parameters',
      'jsonb_array_length(processed_payrolls.employees) AS employees',
      'processed_payrolls.employees AS listEmployees',
      'processed_payrolls.concepts AS listConcepts',
      'processed_payrolls.payroll_id',
      'processed_payrolls.errors',
      'payrolls.code as payrollCode',
      'payrolls.alter_codes_concepts as alterCodesConcepts',
      'payrolls.alter_names_concepts as alterNamesConcepts',
      'companies.code as companyCode',
      'processed_payrolls.process_request_id as processRequestId',
      'closed_payrolls.id as closedPayrollId',
      'COALESCE(closed_payrolls.is_paid, false) as isPaid'
    ],
    join: [
      'LEFT JOIN payrolls ON processed_payrolls.payroll_id=payrolls.id',
      'LEFT JOIN processes ON processed_payrolls.process_id=processes.id',
      'LEFT JOIN companies ON payrolls.company_id=companies.id',
      'LEFT JOIN payroll_status ON processed_payrolls.payroll_status_id=payroll_status.id',
      'LEFT JOIN closed_payrolls ON closed_payrolls.processed_payroll_id = processed_payrolls.id AND closed_payrolls.is_deleted = false'
    ],
    where: [`processed_payrolls.id='${id}'`],
    options: {
      outputFormat: 'json',
      allowDeleted: true
    }
  })

  return response[0].results[0]
}

export async function getClosedProcesses(): Promise<any> {
  const response: any = await getData({
    tables: ['pg_closed_payrolls'],
    fields: [
      'DISTINCT ON (processes.name) closed_payrolls.id',
      'processes.name as process',
      'processed_payrolls.start_date',
      'processed_payrolls.end_date'
    ],
    join: [
      'JOIN processed_payrolls ON closed_payrolls.processed_payroll_id = processed_payrolls.id',
      'JOIN processes ON processed_payrolls.process_id = processes.id'
    ],
    where: ['closed_payrolls.payroll_id = :payrollId'],
    modifier: ['ORDER BY process ASC, processed_payrolls.start_date DESC']
  })

  return response
}

export async function getAccountingDetails(closedId: string): Promise<any> {
  const response: any = await getData({
    tables: ['pg_integration_actions'],
    fields: [
      'integration_actions.id',
      'integration_actions.result_detail',
      'integration_actions.errors',
      'integration_actions.user',
      'integration_actions.created_at',
      'process_status.code as status_code'
    ],
    join: [
      'JOIN process_status ON integration_actions.process_status_id = process_status.id'
    ],
    where: [`closed_payroll_id='${closedId}'`],
    modifier: ['ORDER BY integration_actions.created_at DESC'],
    options: {
      outputFormat: 'json',
      allowDeleted: true
    }
  })

  return response[0].results
}

export async function fetchLatestClosedProcesses(): Promise<any> {
  const response: any = await getData({
    tables: ['pg_closed_payrolls'],
    fields: [
      'closed_payrolls.id',
      'processes.name as process',
      'processed_payrolls.start_date',
      'processed_payrolls.end_date'
    ],
    join: [
      'JOIN processed_payrolls ON closed_payrolls.processed_payroll_id = processed_payrolls.id',
      'JOIN processes ON processed_payrolls.process_id = processes.id'
    ],
    where: [
      'closed_payrolls.payroll_id = :payrollId',
      `processed_payrolls.start_date >= date_trunc('month', current_date) - interval '30 months'`,
      `processed_payrolls.start_date < date_trunc('month', current_date) + interval '4 month'`
    ],
    modifier: ['ORDER BY process ASC, processed_payrolls.start_date DESC']
  })

  return response
}

export async function getMovements(
  data: any,
  offset?: number,
  size?: number
): Promise<{ rows: Row[] }> {
  const response: any = await http.post('historic/get-page', {
    ...data,
    offset: offset || data?.offset || 0,
    size: size || data?.size || 10
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }

  return response?.data
}

export async function getHeaders(
  data: any
): Promise<{ headers: Header[]; footer: Footer[] }> {
  const response: any = await http.post('historic/get-header', data)

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }

  return response?.data
}

export async function getHistoricOld(
  data: any,
  offset?: number,
  size?: number,
  headers: boolean = false
): Promise<Movements | any> {
  const historicAws = await getHistoric(data, offset, size, headers)
  if (historicAws?.rows?.length > 0) {
    return historicAws
  }
  const pageReq = {
    ...data,
    offset: offset ?? data?.offset ?? 0,
    size: size ?? data?.size ?? 10
  }
  const rowsPromise = getMovements(pageReq, pageReq.offset, pageReq.size)

  if (headers) {
    const [rowsRes, headRes] = await Promise.all([
      rowsPromise,
      getHeaders(data)
    ])

    if (!rowsRes || !('rows' in rowsRes)) return rowsRes
    if (!headRes || !('headers' in headRes) || !('footer' in headRes))
      return headRes
    return {
      rows: rowsRes.rows,
      headers: headRes.headers,
      footer: headRes.footer,
      offset: pageReq.offset,
      size: pageReq.size
    }
  } else {
    const rowsRes = await rowsPromise
    if (!rowsRes || !('rows' in rowsRes)) return rowsRes
    return {
      rows: rowsRes.rows,
      headers: [],
      footer: [],
      offset: pageReq.offset,
      size: pageReq.size
    }
  }
}

export async function getHistoric(
  data: any,
  offset?: number,
  size?: number,
  headers: boolean = false
): Promise<Movements> {
  try {
    const response: any = await httpAws.post('get-movements', {
      ...data,
      offset: offset ?? data?.offset ?? 0,
      size: size ?? data?.size ?? 10,
      headers,
      withBearer: true
    })

    if (response?.data?.data?.error) {
      return response?.data?.data?.error
    }

    return response?.data
  } catch (error) {
    return { headers: [], footer: [], rows: [], offset: 0, size: 0 }
  }
}

export async function getSearch(data: any): Promise<{ rows: Row[] }> {
  const historicAws = await getHistoric(data)
  if (historicAws?.rows?.length > 0) {
    return historicAws
  }
  const response: any = await http.post('historic/get-search', {
    ...data,
    search: data?.search || ''
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }

  return response?.data
}

export async function closePayroll(data: ClosePayroll): Promise<boolean> {
  const response: any = await http.post('calculation/close', data)

  if (response?.data?.data?.error) {
    return false
  }

  return true
}

export async function updateDataHistory(id: string): Promise<boolean> {
  const response: any = await http.put('calculation/close/' + id, {})

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function generateBankFiles(
  closedPayrollId: string,
  templateIds?: string[]
): Promise<boolean> {
  const response: any = await http.post(
    `calculation/close/${closedPayrollId}/bank-files`,
    templateIds?.length ? { templateIds } : {}
  )

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function markPayrollAsPaid(
  closedPayrollId: string
): Promise<boolean> {
  if (!closedPayrollId) return false
  const response: any = await http.put(
    `calculation/close/${closedPayrollId}/is-paid`,
    {}
  )

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function sendExportProcessedPayroll(
  processedPayrollId: string,
  observation: string
): Promise<{ code: string; message: string }> {
  const response: any = await http.post(
    'integrations-apex/' + processedPayrollId,
    { reason: observation }
  )
  let res = {
    code: 'error',
    message: ''
  }
  res.message = response?.data?.message
  if (response?.data?.data?.error) {
    res.message = 'Ha ocurrido un error al enviar la exportación'
  }
  if (response?.data?.code === 'success') {
    res.code = 'success'
  }
  return res
}

export async function sendExportProcessedPayrollSAP(
  closeId: string,
  startDate: string,
  endDate: string,
  processCode: string,
  payrollId?: string
): Promise<{ code: string; message: string }> {
  const response: any = await http.post('integration-action', {
    integrationType: 'sap-service',
    actionType: 'create-accounting',
    parameters: {
      closeId,
      entity: 'closed_payrolls',
      payrolls: [payrollId],
      startDate,
      endDate,
      processes: [processCode]
    }
  })
  let res = {
    code: 'error',
    message: ''
  }
  res.message = response?.data?.message
  if (response?.data?.data?.error) {
    res.message = 'Ha ocurrido un error al enviar la exportación a sap'
  }
  if (response?.status == 200) {
    res.code = 'success'
  }
  return res
}
